module.exports = __webpack_public_path__ + "img/university-header-right-texture.b33c6116.svg";